import { Tendency } from '@cast/shared-types';

export const getSummaryTendency = (value?: number): Tendency => {
  if (!value || value === 0) {
    return 'stable';
  }

  if (value < 0) {
    return 'up';
  }

  return 'down';
};
